<template>
  <div class="q-gutter-md">
    <p class="text-subtitle1">Personal</p>
    <q-separator />
    <q-input
      label="First Name"
      :model-value="firstName"
      outlined
      @update:modelValue="$emit('update:firstName', $event)"
    />
    <q-input
      label="Last Name"
      :model-value="lastName"
      outlined
      @update:modelValue="$emit('update:lastName', $event)"
    />
    <q-input
      label="Email"
      :model-value="email"
      outlined
      @update:modelValue="$emit('update:email', $event)"
    />
    <PhoneInput
      label="Phone"
      :model-value="phone"
      outlined
      @update:modelValue="$emit('update:phone', $event)"
      required
    />
    <date-picker
      label="Date of Birth"
      :model-value="dateOfBirth"
      :max-date="now"
      outlined
      @update:modelValue="$emit('update:dateOfBirth', $event)"
    />

    <p class="text-subtitle1">File</p>
    <q-separator />
    <q-input
      label="File Reference Number (Optional)"
      :model-value="fileRefNo"
      outlined
      @update:modelValue="$emit('update:fileRefNo', $event)"
    />
    <date-picker
      label="Date of Loss"
      :model-value="dateOfLoss"
      :min-date="dateOfBirth"
      :max-date="now"
      outlined
      @update:modelValue="$emit('update:dateOfLoss', $event)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DatePicker from '@/components/form/DatePicker.vue';
import { PhoneInput, isPhoneValid } from '@/components/form/phone';

interface Data {
  now: Date,
}

export default defineComponent({
  emits: [
    'done',
    'update:dateOfBirth',
    'update:dateOfLoss',
    'update:email',
    'update:fileRefNo',
    'update:firstName',
    'update:lastName',
    'update:phone',
  ],
  components: { DatePicker, PhoneInput },
  props: {
    firstName: {
      type: String,
      required: true,
    },
    lastName: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    phone: {
      type: String,
      required: true,
    },
    dateOfBirth: {
      type: String,
      required: true,
    },
    dateOfLoss: {
      type: String,
      required: true,
    },
    fileRefNo: String,
  },
  data(): Data {
    return {
      now: new Date(),
    };
  },
  computed: {
    isDone(): boolean {
      return (
        this.firstName !== '' && this.lastName !== ''
        && this.email !== '' && this.dateOfBirth !== ''
        && this.dateOfLoss !== ''
        && isPhoneValid(this.phone, true)
      );
    },
  },
  watch: {
    isDone(isDone: boolean) {
      this.$emit('done', isDone);
    },
  },
});
</script>
